import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../constants';
import { useAppSelector } from '../../hooks';
import { OrganizationStatus, Permissions, SettingsTab } from '../../types';
import { conditionalArray } from '../../utils';
import { Avatar, Icon, Icons } from '../shared';
import SidebarButtonGroup from './SidebarButtonGroup';

const SettingsSidebarContent = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { user, organization } = useAppSelector((state) => state.auth);

  const permissions = user?.permissions || [];
  const { isHiringModuleEnabled, status } = organization || {};

  // Permissions
  const canConnectExternalIntegrations = permissions.includes(Permissions.CONNECT_EXTERNAL_INTEGRATION);
  const canViewHiring = permissions.includes(Permissions.VIEW_CANDIDATE);
  const canViewOrgSettings = permissions.includes(Permissions.MANAGE_ORG_SETTINGS);

  const isTrialOrg = status === OrganizationStatus.TRIAL;
  const isHiringDisabled = !isHiringModuleEnabled || isTrialOrg;

  const items = useMemo(
    () => [
      {
        id: SettingsTab.ACCOUNT,
        endElement: <Avatar label={user?.name} size={16} imgSrc={user?.picture} />,
      },
      {
        id: SettingsTab.PEOPLE,
        endElement: <Icons icon={Icon.USERS} />,
      },
      ...conditionalArray(canViewOrgSettings, {
        id: SettingsTab.ORGANIZATION,
        endElement: <Icons icon={Icon.SETTINGS} />,
      }),
      ...conditionalArray(canViewHiring, {
        id: SettingsTab.HIRING,
        disabled: isHiringDisabled,
        endElement: <Icons icon={isHiringDisabled ? Icon.LOCK : Icon.USER_SEARCH} />,
      }),
      ...conditionalArray(canConnectExternalIntegrations, {
        id: SettingsTab.INTEGRATIONS,
        disabled: isTrialOrg,
        endElement: <Icons icon={isTrialOrg ? Icon.LOCK : Icon.PLUG} />,
      }),
    ],
    [
      user,
      isHiringDisabled,
      canViewHiring,
      isHiringDisabled,
      isTrialOrg,
      canConnectExternalIntegrations,
      canViewOrgSettings,
    ]
  );

  return (
    <SidebarButtonGroup
      items={items.map((item) => ({
        ...item,
        active: pathname.includes(item.id),
        onClick: () => navigate(AppRoutes.SETTINGS + '/' + item.id, { replace: true }),
      }))}
    />
  );
};

export default SettingsSidebarContent;
